import { render, staticRenderFns } from "./PersonalityResult.vue?vue&type=template&id=64830f4a&scoped=true&"
import script from "./PersonalityResult.vue?vue&type=script&lang=js&"
export * from "./PersonalityResult.vue?vue&type=script&lang=js&"
import style0 from "./PersonalityResult.vue?vue&type=style&index=0&id=64830f4a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64830f4a",
  null
  
)

export default component.exports